import { render, staticRenderFns } from "./UploadSuccess.vue?vue&type=template&id=18e20a26&scoped=true"
import script from "./UploadSuccess.vue?vue&type=script&lang=js"
export * from "./UploadSuccess.vue?vue&type=script&lang=js"
import style0 from "./UploadSuccess.vue?vue&type=style&index=0&id=18e20a26&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e20a26",
  null
  
)

export default component.exports